import type { PropsWithChildren, ReactNode } from "react";
import { NavLink, useLocation, type NavLinkProps } from "react-router";

import { cn } from "shared/utils/cn";

type Props = {
  className?: string;
  icon: ReactNode;
  title: ReactNode;
} & NavLinkProps;

export const Item = (props: PropsWithChildren<Props>) => {
  const { pathname } = useLocation();
  const { className, title, icon, ...navLinkProps } = props;
  return (
    <NavLink
      className={() => {
        const to =
          typeof navLinkProps.to === "string"
            ? navLinkProps.to
            : navLinkProps.to.pathname;
        const isActive = to && pathname.startsWith(to);
        return cn(
          "flex flex-col items-center justify-center opacity-35 transition-opacity hover:opacity-50",
          isActive && "opacity-100",
          className
        );
      }}
      {...navLinkProps}
    >
      {icon}
      <span className="text-white">{title}</span>
    </NavLink>
  );
};
